import React from 'react';
import { Grid } from '@material-ui/core';
import { Statistics } from '../../modules';
import { PaddedContainer } from '../../ui-kit';

const StatisticsView = () => (
    <PaddedContainer spacing={3}>
        <Grid item xs={12}>
        </Grid>
        <Grid item xs={12}>
            <Statistics />
        </Grid>
    </PaddedContainer>
);

export default StatisticsView;
